import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import { Link, useParams } from 'react-router-dom'
import { useForm } from '../../../hooks/useForm'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import { ApiUrl } from '../../../services/ApiRest'
import { quillModules } from '../../../functions/quillComponent';


const PartnerEdit = () => {

    const { partnerId } = useParams();

    const [imgLogo, setimgLogo] = useState([]);
    const [img1, setimg1] = useState([]);
    const [img2, setimg2] = useState([]);

    const [newData, setnewData] = useState({
        partner_name: '',
        province: '',
        city: ' ',
        benefit: '',
        business_hours: '',
        address: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        google_maps: '',
        phone: '',
        message_for_whatsapp: '',
        about_of_business: '',
        manager: '',
        category: ''
    })

    const cleanHTML = (html) => {
        return html.replace(/[\u200B-\u200D\uFEFF]/g, '');
    };

    const [is_active, setis_active] = useState(false)
    const [isLoading, setisLoading] = useState(false)


    const getData = async () => {
        await axios.get(ApiUrl + "partner-show/" + partnerId)
            .then(response => {
                const data = response.data[0];

                setis_active(data.is_active === true || data.is_active === '1' || data.is_active === 1 || data.is_active === 'true');


                setnewData({
                    partner_name: data.partner_name,
                    province: data.province,
                    city: data.city,
                    benefit: data.benefit,
                    business_hours: data.business_hours,
                    address: data.address,
                    facebook: data.facebook,
                    instagram: data.instagram,
                    tiktok: data.tiktok,
                    google_maps: data.google_maps,
                    phone: data.phone,
                    message_for_whatsapp: data.message_for_whatsapp,
                    about_of_business: cleanHTML(data.about_of_business),
                    manager: data.manager,
                    category: data.category

                })

                console.log(data);

            })
            .catch(e => {
                console.log(e)
            })
    }


    const onSubmit = async (event) => {
        setisLoading(true)

        event.preventDefault();
        const f = new FormData();

        f.append("partner_id", partnerId);
        f.append("partner_name", newData.partner_name);
        f.append("province", newData.province);
        f.append("city", newData.city);
        f.append("benefit", newData.benefit);
        f.append("business_hours", newData.business_hours);
        f.append("address", newData.address);
        f.append("facebook", newData.facebook);
        f.append("instagram", newData.instagram);
        f.append("tiktok", newData.tiktok);
        f.append("google_maps", newData.google_maps);
        f.append("phone", newData.phone);
        f.append("message_for_whatsapp", newData.message_for_whatsapp);
        f.append("about_of_business", newData.about_of_business);
        if (img1[0] != undefined) {
            f.append("img_1", img1[0]);
        }

        if (img2[0] != undefined) {
            f.append("img_2", img2[0]);
        }
        if (imgLogo[0] != undefined) {
            f.append("img_logo", imgLogo[0]);
        }

        f.append("manager", newData.manager);
        f.append("is_active", is_active);
        f.append("category", newData.category);

        console.log(Object.fromEntries(f));

        await axios.post(ApiUrl + 'partner-edit', f)
            .then(response => {
                var resp = response.data;
                // dispatch(statusSave(false));          

                console.log(resp);
                if (resp.success) {
                    toast.success("Partner Agregado exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    // dispatch(statusSave(false));          
                    // dispatch(addTourToMonthly(resp.data));       
                    setisLoading(false)

                } else {
                    toast.error("El Partner no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                    // dispatch(statusSave(false));    
                    setisLoading(false)


                }
            })
            .catch(e => {
                console.log(e)
                toast.error("Error de Servidor, Contáctese con soporte", { position: toast.POSITION.BOTTOM_RIGHT });
                setisLoading(false)

                // toast.error(""+e+"  !", {position: toast.POSITION.BOTTOM_RIGHT});           
                // dispatch(statusSave(false));          

            })



    }

    const updateImgLogo = e => {
        setimgLogo(e);
    }
    const updateImg1 = e => {
        setimg1(e);
    }

    const updateImg2 = e => {
        setimg2(e);
    }

    const handlebenefitChange = value => {
        setnewData(prevState => ({
            ...prevState,
            benefit: value
        }));
    };

    const handleBusiessHoursChange = value => {
        // onInputChange({ target: { name: 'business_hours', value } });
        setnewData(prevState => ({
            ...prevState,
            business_hours: value
        }));
    };

    const handleAboutOfChange = value => {
        // onInputChange2({ target: { name: 'about_of_business', value } });
        setnewData(prevState => ({
            ...prevState,
            about_of_business: value
        }));
        
    };

    

    const handleIncludeChange = value => {
        setnewData(prevState => ({
            ...prevState,
            include: value
        }));
    };



    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setnewData({
            ...newData,
            [name]: value
        });
    }

    useEffect(() => {
        getData();

    }, [])

    return (

        <div className='row'>
            <div className='col-12 '>
                <div className="card">
                    <div className="card-header">
                        EDITAR PARTNER
                    </div>
                    <div className="card-body">
                        <form onSubmit={onSubmit}>
                            <div className='row'>
                                <div className='col-12 col-sm-6'>
                                    <div className="form-group">
                                        <label >Nombre de la empresa</label>
                                        <input type="text" name='partner_name' value={newData.partner_name} onChange={onInputChange} className="form-control" placeholder='Ej: Camping Sobre las Nubes' required></input>
                                    </div>
                                </div>
                                <div className='col-6 col-sm-3'>
                                    <div className="form-group">
                                        <label >Provincia</label>
                                        <input type="text" name='province' value={newData.province} onChange={onInputChange} className="form-control" placeholder='Ej: Puñay' required></input>
                                    </div>
                                </div>
                                <div className='col-6 col-sm-3'>
                                    <div className="form-group">
                                        <label >Ciudad</label>
                                        <input type="text" name='city' value={newData.city} onChange={onInputChange} className="form-control" placeholder='Ej: Puñay' required></input>
                                    </div>
                                </div>
                            </div>


                            <div className='row'>

                                <div className='col-12 col-sm-12'>
                                    <div className="form-group">
                                        <label >Beneficio para clientes</label>
                                        {/* <textarea className="form-control" name='city' value={city} onChange={onInputChange} id="exampleFormControlTextarea1" rows="2" required></textarea> */}
                                        <ReactQuill  modules={quillModules} theme="snow" value={newData.benefit} onChange={handlebenefitChange} />

                                    </div>
                                </div>

                                <div className='col-12 col-sm-12'>
                                    <div className="form-group">
                                        <label >Horario de atención</label>
                                        {/* <textarea className="form-control" name='city' value={city} onChange={onInputChange} id="exampleFormControlTextarea1" rows="2" required></textarea> */}
                                        <ReactQuill modules={quillModules} theme="snow" value={newData.business_hours} onChange={handleBusiessHoursChange} />
                                       
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 col-sm-6 col-md-3'>
                                    <div className="form-group">
                                        <label >Facebook</label>
                                        <input type="text" name='facebook' value={newData.facebook} onChange={onInputChange} className="form-control" ></input>

                                    </div>
                                </div>

                                <div className='col-6 col-sm-6 col-md-3'>
                                    <div className="form-group">
                                        <label >Instagram</label>
                                        <input type="text" name='instagram' value={newData.instagram} onChange={onInputChange} className="form-control" ></input>

                                    </div>
                                </div>
                                <div className='col-6 col-sm-6 col-md-3'>
                                    <div className="form-group">
                                        <label >Tik tok</label>
                                        <input type="text" name='tiktok' value={newData.tiktok} onChange={onInputChange} className="form-control" ></input>
                                    </div>
                                </div>
                                <div className='col-6 col-sm-6 col-md-3'>
                                    <div className="form-group">
                                        <label >URL Google Maps</label>
                                        <input type="text" name='google_maps' value={newData.google_maps} onChange={onInputChange} className="form-control" ></input>
                                    </div>

                                </div>
                            </div>


                            <div className='row'>
                                <div className='col-12 col-sm-6'>
                                    <div className="form-group">
                                        <label >Dirección</label>
                                        <input type="text" name='address' value={newData.address} onChange={onInputChange} className="form-control" placeholder='Ej: 39.49' required></input>

                                    </div>
                                </div>
                                <div className='col-12 col-sm-6'>
                                    <div className="form-group">
                                        <label >Administrador</label>
                                        <input type="text" name='manager' value={newData.manager} onChange={onInputChange} className="form-control" required></input>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12 col-sm-3'>
                                    <div className="form-group">
                                        <label >Teléfono de Contacto</label>
                                        <input type="text" name='phone' value={newData.phone} onChange={onInputChange} className="form-control" placeholder='Ej: 0961119670' required ></input>
                                    </div>
                                </div>

                                <div className='col-12 col-sm-6'>
                                    <div className="form-group">
                                        <label >Mensaje de whatsapp</label>
                                        <input type="text" name='message_for_whatsapp' value={newData.message_for_whatsapp} onChange={onInputChange} className="form-control" placeholder='Hola me gustaría ...' required ></input>
                                    </div>
                                </div>

                                <div className='col-12 col-sm-3'>
                                    <div className="form-group">
                                        <label >Categoría</label>
                                        <select className="form-select" name="category" value={newData.category} onChange={onInputChange} aria-label="Default select example" required>
                                            <option value="">Seleccione una opción</option>
                                            <option value="Alojamiento">Alojamiento</option>
                                            <option value="Restaurantes">Restaurantes</option>
                                            <option value="Entretenimiento y Coctelería">Entretenimiento y Coctelería</option>
                                            <option value="Vestimenta y Accesorios">Vestimenta y Accesorios</option>
                                            <option value="Productos Nutricionales">Productos Nutricionales</option>
                                            <option value="Salud y Bienestar">Salud y Bienestar</option>
                                            <option value="Movilidad Privada">Movilidad Privada</option>
                                            <option value="Tecnología y Dispositivos">Tecnología y Dispositivos</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 col-sm-3'>
                                    <div className="form-group">
                                        <label >Imagen Logo</label>
                                        <input name="img_logo" onChange={(e) => updateImgLogo(e.target.files)} className="form-control form-control-sm" id="formFileSm" type="file" accept="image/png, image/gif, image/jpeg" ></input>
                                    </div>
                                </div>
                                <div className='col-6 col-sm-3'>
                                    <div className="form-group">
                                        <label >Imagen Promocional 1</label>
                                        <input name="img_1" onChange={(e) => updateImg1(e.target.files)} className="form-control form-control-sm" id="formFileSm" type="file" accept="image/png, image/gif, image/jpeg" ></input>
                                    </div>
                                </div>
                                <div className='col-6 col-sm-3'>
                                    <div className="form-group">
                                        <label >Imagen Promocional 2</label>
                                        <input name="img_2" onChange={(e) => updateImg2(e.target.files)} className="form-control form-control-sm" id="formFileSm" type="file" accept="image/png, image/gif, image/jpeg" ></input>
                                    </div>
                                </div>

                                <div className='col-6 col-md-3'>
                                    <div className="">
                                        <label className="form-label">Activo</label>

                                        <div className="form-check form-switch" style={{ textAlign: 'center' }}>
                                            <input className="form-check-input" name='is_active' type="checkbox" id="flexSwitchCheckDefault" style={{ fontSize: '1.3rem' }} checked={is_active} onChange={() => setis_active(!is_active)}></input>
                                            <label className="form-check-label" style={{ alignItems: 'center' }}>Mostrar en web</label>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className='row'>
                                <div className='col-12 col-sm-12'>
                                    <div className="form-group">
                                        <label >Acerca de la empresa</label>
                                        <ReactQuill modules={quillModules} theme="snow" value={newData.about_of_business} onChange={handleAboutOfChange} />

                                        {/* <textarea className="form-control" name='benefit' value={benefit} onChange={onInputChange} id="exampleFormControlTextarea1" rows="2" required></textarea> */}
                                    </div>
                                </div>

                            </div>

                            <hr></hr>

                            <button type="submit" className="btn btn-success" disabled={isLoading} >Actualizar Partner</button> &nbsp;
                            <Link to={'../partners'}>
                                <button type="button" className="btn btn-danger">Regresar</button> &nbsp;
                            </Link>
                        </form>

                    </div>
                </div>
            </div>
            <ToastContainer theme="colored" />

        </div>
    )
}

export default PartnerEdit
